import { gettext } from '@/translations/gettext.setup';

const { $gettext } = gettext;

const imageryLayers = [
  {
    iconUrl: 'imagery/mapbox-satellite.png',
    mapType: 'satellite',
    name() {
      return $gettext('Satellite');
    },
    tooltip() {
      return $gettext('Google Satellite');
    }
  },
  {
    iconUrl: 'imagery/mapbox-streets.png',
    mapType: 'roadmap',
    name() {
      return $gettext('Roadmap');
    },
    tooltip() {
      return $gettext('Google Roadmap');
    }
  },
];

export default imageryLayers;